import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Features } from '../../business-entities/user-role-view-model';
import { DealerHolidayViewModel } from '../../business-entities/dealer-holiday-list-view-model';
import { DealerOpeningHoursViewModel } from '../../business-entities/dealer-opening-hours-view-model';
import { AppointmentServiceDetails } from '../../business-entities/appointment-service-details-view-model';
import { JobList } from '../../business-entities/appointment-Job-list-view-model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { AppointmentPlanningService } from '../../business-services/appointment-planning.service';
import { SaveAppointmentPlanning } from '../../business-entities/save-appointment-planning.model';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-block-mechanic',
  templateUrl: './block-mechanic.component.html',
  styleUrls: ['./block-mechanic.component.css']
})
export class BlockMechanicComponent implements OnInit, AfterViewChecked{

  @Input() mechanicName: string;
  @Input() startDate: string;
  @Input() durationValue: string = '0.00';
  @Input() unavailableDates: string[] = [];
  @Input() endTime: string;
  @Input() dealerId: string;
  @Input() mechanicStartTime: string;
  @Input() isEditMechancBooking = false
  @Input() dealerHolidays: DealerHolidayViewModel[] = [];
  @Input() dealerWorkingHours: DealerOpeningHoursViewModel[] = [];
  @Input() calenderStartDate: string;
  @Input() isServicesAdded: boolean = true;
  @Input() isUpdateBooking: boolean;
  @Input() totalTimeDuration: any = "";
  @Input() boxNumber: any;
  @Input() isAddBooking: any;
  @Input() isView: boolean = false;
  @Input() dealerName: string = '';
  @Input() mechanicEfficiency:number;
  @Input() calendarNumber:number= 0;
  @Input() pId:number=0;
  @Input() serviceDetail:AppointmentServiceDetails;
  addPlanningJobList:JobList[]=[];
  mechanicStartDate: string;
  mechanicDateFormat: string;
  startHours: string = '0';
  mechanicNameValue: string;
  isStartTime: boolean = false;
  isEndTime: boolean = false;
  startMin: string = '0';
  dateValue: string;
  timeValue: string;
  isValid: boolean;
  endDateTime: Date;
  endDateTimeValue: string;
  unavailableDateValues: string[] = [];
  durationHours: string = '0';
  durationMinutes: string = '0';
  serviceHour: string = '0';
  serviceMinutes: string = '0';
  selectedWO:any;
  licensePlateClass:string;
  formatDate: string = 'd.m.Y';
  endTimeValue: string;
  features: Features[] = [];
  mechanicList=[];
  workorderList=[];
  appoitmentId:number=0;
  mechanicId:number=0;
  disableDatesOfCalender = Array<string>();
  isDisplyJob: boolean = false;
  dmsSyncRequired: boolean = false;
  openPanels: Array<string> = ['fifth'];
  reason:string = '';
  @ViewChild("minuteInput") minuteInput: ElementRef;
  @ViewChild("durationminuteInput") durationMinuteInput: ElementRef;
  @ViewChild('rentalCarBookingCalendar') rentalCarBookingCalendar: ElementRef;
  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private datePipe: DatePipe,
    private globalSetting: GlobalSetting,
    private secureStorage: SecureStorage,
    private appointmentPlanningService: AppointmentPlanningService,
    private changeDetector: ChangeDetectorRef
  ) { 
    
  }
  ngAfterViewChecked(): void {
    if (this.dealerWorkingHours?.length > 0) {
      this.disableDealerNotOpenDates();
    }
  }

  
  ngOnInit() {
    this.dmsSyncRequired = localStorage.getItem("Theme") === 'bnh';
    this.addPlanningJobList = [];
    this.mechanicId = this.pId;
    this.mechanicNameValue = this.mechanicName;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    if (this.unavailableDates?.length === 0) {
      // Empty on purpose
    }
    this.mechanicStartDate = this.startDate;
    this.mechanicDateFormat = Utility.GetFormattedDate(new Date(this.mechanicStartDate));
    if (!this.isView) {
      this.initializeForNonView();
    } else {
      this.initializeForView();
    }
    if (this.dealerHolidays?.length > 0) {
      this.disableDatesOfCalender = this.disableDealerHolidayDates();
    }
    if(this.isAddBooking){
      this.isDisplyJob = true;
      this.addJobsFromServiceDetail();
    }
   else {
      this.GetWoMechanicList()
    }
    this.durationMinutes = this.addLeadingZeros(+this.durationMinutes, 2);
    this.durationMinutes = this.findTime(this.durationMinutes).toString();
    this.durationHours = this.addLeadingZeros(+this.durationHours, 2);
    if(this.durationMinutes == '60')
    {
      this.durationHours = (+this.durationHours + 1).toString();
      this.durationMinutes = '00';
    }
    this.serviceHour = this.addLeadingZeros(+this.serviceHour, 2);
    this.serviceMinutes = this.addLeadingZeros(+this.serviceMinutes, 2);
  }
  initializeForNonView() {
    if (this.isEditMechancBooking) {
      this.initializeForEditBooking();
    } else {
      this.initializeForNewBooking();
    }
  }
  initializeForEditBooking() {
    this.endDateTimeValue = this.endTime;
    this.dateValue = this.mechanicStartDate;
    this.durationHours = Math.floor(+this.durationValue / 60).toString();
    this.durationMinutes = (+this.durationValue % 60).toString();
    const arr = this.totalTimeDuration.split(":");
    this.serviceHour = arr[0]?.toString();
    this.serviceMinutes = arr[1]?.toString();
    this.startHours = this.mechanicStartTime.split(':')[0];
    this.startMin = this.mechanicStartTime.split(':')[1];
    this.isStartTime = true;
    this.OnStartTimeChange();
  }
  initializeForNewBooking() {
    this.endDateTimeValue = this.endTime;
    this.dateValue = this.mechanicStartDate;
    const arr = this.totalTimeDuration.split(":");
    this.serviceHour = arr[0]?.toString();
    this.serviceMinutes = arr[1]?.toString();
    const time = Utility.GetEfficientPlanningTime(this.mechanicEfficiency, ((+this.serviceHour * 60) + +this.serviceMinutes));
    const hr = (time/60).toString()?.split(".")?.[0];
    const minute = time - (60*+hr);
    this.durationHours = Number(hr) >= 0 ? hr.toString() : '00';
    this.durationMinutes = (Number(minute) >= 0 ? minute.toString() : '00');
    if (this.mechanicStartTime && this.mechanicStartTime !== undefined) {
      this.startHours = this.mechanicStartTime;
      this.startMin = this.boxNumber;
      this.isStartTime = true;
      this.OnStartTimeChange();
    }
  }
  initializeForView() {
    this.startHours = new Date(this.mechanicStartDate).getHours().toString();
    this.startMin = this.findTime(new Date(this.mechanicStartDate).getMinutes()).toString();
    this.isStartTime = true;
    this.OnStartTimeChange();
  }

  addJobsFromServiceDetail() {
    this.serviceDetail?.appointmentJobList?.forEach((job) => {
      const obj = {
        jobId: job.jobId,
        description: job.description,
        totalTime: job.totalTime
      };
      this.addPlanningJobList.push(obj);
    });
  }

  getNotOpenDaysOfDealer(): number[] {
    const dealerNotOpenDaysList: number[] = [];
    const dealerOpenDaysList: number[] = [];
    let dealerNotOpenDays2DList = this.dealerWorkingHours?.filter(x => x.open).map(x => x.dayNumber);
    dealerNotOpenDays2DList.forEach(days => {
      dealerOpenDaysList.push(days);
    });
    for (let i = 0; i <= 6; i++) {
      if (dealerOpenDaysList.indexOf(i) === -1) {
        dealerNotOpenDaysList.push(i);
      }
    }
    return dealerNotOpenDaysList;
  }
  GetWoMechanicList() {
      this.appointmentPlanningService.GetWOMechanicList(this.dealerId, this.dmsSyncRequired).then((res)=>{
        if(res.responseObject)
        {
          if(res.responseObject.mechanicList?.length > 0){
            this.mechanicList = res.responseObject.mechanicList
          }
          if(res.responseObject.workorderList?.length > 0){
            this.workorderList = res.responseObject.workorderList
            this.workorderList = this.workorderList?.filter(x=>x.totalTime > 0);
            this.serviceHour = '00';
            this.serviceMinutes = '00';
            this.durationHours = '00';
            this.durationMinutes = '00';
          }
        }
      })
  }

  resetSelectWO(){
    this.appoitmentId = 0;
    this.serviceHour = '00';
    this.serviceMinutes = '00';
    this.durationHours = '00';
    this.durationMinutes = '00';
    this.isDisplyJob = false;
    this.selectedWO = null;
  }

  onChangeWo(event){
    if(event != undefined || event != null){
      let WO = this.workorderList?.find(x=>x.appoitmentId == event);
      this.appointmentPlanningService.GetMechanicJobListForWO(WO?.workorderNumber).then((res)=>{
        if(res.responseObject)
        {
          if(res.responseObject?.errorCount>0)
          {
            this.addPlanningJobList=[];
          }
          else
          {
            this.addPlanningJobList=res.responseObject.pendingJobList;
          }
        }
      })
      this.isDisplyJob = true;
      this.appoitmentId = +event;
      this.selectedWO = this.workorderList?.find(x=>x.appoitmentId === this.appoitmentId)
      let time = this.selectedWO?.totalTime;
      let arr = time.toString().split(".")
      this.serviceHour = arr[0]?.toString();
      this.serviceMinutes = arr[1]?.toString();
      this.serviceMinutes = this.addLeadingZeros(+this.serviceMinutes, 2);
      this.serviceMinutes = this.findTime(this.serviceMinutes).toString();
      this.serviceHour = this.addLeadingZeros(+this.serviceHour, 2);
      this.onChangeMechanic(this.mechanicId);
    }
  }
  onChangeMechanic(event){
    this.mechanicId = +event;
    this.mechanicEfficiency = this.mechanicList.find(x=>x.mechanicId == this.mechanicId)?.efficiency;
    if(this.mechanicEfficiency > 0){
      let time = Utility.GetEfficientPlanningTime(this.mechanicEfficiency, ((+this.serviceHour * 60) + +this.serviceMinutes));
      let hr = (time/60).toString()?.split(".")?.[0];
      let minute = time - (60*+hr);
      this.durationHours = Number(hr) >= 0 ? hr.toString() : '00';
      this.durationMinutes = (Number(minute) >= 0 ? minute.toString() : '00');
      this.durationMinutes = this.findTime(this.durationMinutes).toString();
      if(this.durationMinutes == '60')
      {
        this.durationHours = (+this.durationHours + 1).toString();
        this.durationMinutes = '00';
      }
    }
  }
  disableDealerNotOpenDates(): void {
    this.changeDetector.detectChanges();
    this.enablePreviousClosedDates();
    const calendar = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    this.changeDetector.detectChanges();
    if (calendar && this.dealerWorkingHours) {
      const dealerNotOpenDaysList = this.getNotOpenDaysOfDealer();
      for (const element of calendar) {
        const mainDate = this.getDateStringFromCalenderElement(element);
        const day = this.getFormatedDate(mainDate).getDay();
        const index = dealerNotOpenDaysList.findIndex(x => x === day);
        if (index === -1) {
          element.classList.remove('xdsoft_disabled');
        } else {
          element.classList.add('xdsoft_disabled');
          element.classList.add('closed');
        }
      }
    }
  }
  enablePreviousClosedDates() {
    const closedDates = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date.closed');
    if (closedDates) {
      for (const element of closedDates) {
        element.classList.remove('xdsoft_disabled');
        element.classList.remove('closed');
      }
    }
  }
  disableDealerHolidayDates() {
    this.enablePreviousHolidayDates();
    const disableDatesOfCalender = [];

    this.dealerHolidays?.forEach(x => {
      let InitialDate = Utility.getDateStringToDate(x.startDate);
      while (InitialDate <= Utility.getDateStringToDate(x.endDate)) {
        disableDatesOfCalender.push(Utility.GetFormattedDate(InitialDate));
        InitialDate.setDate(InitialDate.getDate() + 1);
      }
    });

    this.setClassOfCalender('holiday', disableDatesOfCalender);
    this.setClassOfCalender('xdsoft_disabled', disableDatesOfCalender);
    return disableDatesOfCalender;
  }
  enablePreviousHolidayDates() {
    const holidayDates = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date.holiday');
    if (holidayDates) {
      for (const element of holidayDates) {
        element.classList.remove('xdsoft_disabled');
        element.classList.remove('holiday');
      }
    }
  }
  setClassOfCalender(className: string, data: any[], flag: boolean = true): void {
    const calendar = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    if (calendar) {
      // tslint:disable-next-line: no-shadowed-variable
      for (const element of calendar) {
        const mainDate = this.getDateStringFromCalenderElement(element);
        for (const availableDate of data) {
          if (mainDate === availableDate) {
            const action = flag ? 'add' : 'remove';
            element.classList[action](className);
          }
        }
      }
    }
  }

  getDateStringFromCalenderElement(calElement: any): string {
    let dataDate = calElement.getAttribute('data-date');
    const dataMonth = calElement.getAttribute('data-month');
    const dataYear = calElement.getAttribute('data-year');

    if (dataDate.length === 1) {
      dataDate = '0' + dataDate;
    }
    let finalMonthValue = String(+dataMonth + 1);
    if (finalMonthValue.length === 1) {
      finalMonthValue = '0' + finalMonthValue;
    }
    return dataDate + '.' + finalMonthValue + '.' + dataYear;
  }
  getFormatedDate(date: string): Date {
    if (date) {
      const arr = date.split('.').reverse().join('-');
      return new Date(arr);
    }
    return new Date();
  }
  MoveToDurationMinute(e) {
    this.MoveToMinute(e, true);
  }

  MoveToMinute(e, isToDuration = false) {
    //keyss to ignore
    const ignoreKeyCodes: Array<number> = [16, 9];

    //ignore keys check
    if (!ignoreKeyCodes.some(x => x == e.keyCode)) {
      //get the current element
      const target = e.srcElement;
      const maxLength = parseInt(target.attributes["maxlength"].value, 10);
      const myLength = target.value.length;
      //make a length check
      if (myLength >= maxLength) {
        //grab to element to focus on
        let minInput;
        if (isToDuration) {
          minInput = this.durationMinuteInput.nativeElement;
        } else {
          minInput = this.minuteInput.nativeElement;
        }
        if (minInput) {
          //focus the element
          minInput.focus();
        }
      }
    }
  }



  OnDateChanged(date: any) {

    this.mechanicStartDate = date;
    this.mechanicDateFormat = Utility.GetFormattedDate(date);
    this.OnStartTimeChange();
  }

  OnStartTimeChange() {
    this.setStartDateAndTime();
    this.setCalculateEndTime();
  }
  getStartMin(){
    if(this.startMin){
      if(this.startMin.length === 1 ){
        return  '0' + this.startMin;
      }else{
        return this.startMin;
      }
    }else{
      return '00';
    }
  }

  setStartDateAndTime() {
    this.isStartTime = true;
    if (this.mechanicStartDate) {
      this.dateValue = this.mechanicStartDate;
    }
    if ((this.startHours == "" || this.startHours == undefined) && (this.startMin == "" || this.startMin == undefined)) {
      this.timeValue = '00:00';
      this.startHours = '00';
      this.startMin = '00';
    } else {
      this.startMin = this.getStartMin();
      this.startHours = (this.startHours && this.startHours.length == 1) ?
        '0' + this.startHours : this.startHours;
      this.timeValue = this.startHours + ':' + this.startMin;
    }
  }

  setCalculateEndTime(): void {
    const startDateTime = this.calculateStartDateTime();
    this.durationMinutes = this.durationMinutes ? this.durationMinutes : '00';
    if(this.durationMinutes == '60')
    {
      this.durationHours = (+this.durationHours + 1).toString();
      this.durationMinutes = '00';
    }
    this.endDateTime = new Date(startDateTime.getTime() + (+this.durationHours * 60 * 60 * 1000) + (+this.durationMinutes * 60 * 1000));
    this.endTimeValue = this.datePipe.transform(new Date(this.endDateTime), 'HH:mm');
    this.isEndTime = true;
  }

  calculateStartDateTime(): Date {
    return new Date(new Date(this.mechanicStartDate).setHours(+this.startHours, +this.startMin));
  }
  CheckHourDuration() {
    if (this.durationHours != null) {
      this.durationHours = this.addLeadingZeros(+this.durationHours, 2);
    }
  }
  CheckMinuteDuration() {
    if (this.durationMinutes != null) {
      this.durationMinutes = this.addLeadingZeros(+this.durationMinutes, 2);
    }
  }
  addLeadingZeros(num: number, totalLength: number): string {
    let length = String(num)?.length;
    if (length <= 1) {
      return String(num).padStart(totalLength, '0');
    }
    else {
      return String(num);
    }
  }
  async SaveMechanicBlockTime() {
      if (this.ValidateStartTime()) {
        this.OnStartTimeChange();
        const startDateTime = this.calculateStartDateTime();
        let mechanicPlanningViewModel: SaveAppointmentPlanning = {
          appointmentId: this.appoitmentId,
          mechanicId: this.mechanicId,
          startDateTimeToCompare: startDateTime.toUTCString(),
          startDateTime: Utility.ConvertLocalDateToUTCDate(startDateTime),
          // this.datePipe.transform(startDateTime, 'yyyy-MM-dd HH:mm:ss'),
          endDateTimeToCompare: this.endDateTime.toUTCString(),
          endDateTime: Utility.ConvertLocalDateToUTCDate(this.endDateTime),
          // this.datePipe.transform(this.endDateTime, 'yyyy-MM-dd HH:mm:ss'),
          durationInMin: ((+this.durationHours * 60) + +this.durationMinutes),
          startDateTimeLocal: this.datePipe.transform(startDateTime, 'yyyy-MM-dd HH:mm:ss'),
          endDateTimeLocal: this.datePipe.transform(this.endDateTime, 'yyyy-MM-dd HH:mm:ss'),
          dealerId: this.dealerId,
          moduleId: Enums.ModuleNames.Appointment,
          integrationWithDMS: false,
          realtimeDmsSyncAppointment: false,
          CalendarNumber : this.calendarNumber,
          ReasonForBlock: this.reason
        };

        this.features = this.secureStorage.getKeyData('feature');
        if (this.features?.length > 0) {
          mechanicPlanningViewModel.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
          mechanicPlanningViewModel.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
        }
        if (this.isUpdateBooking) {
          this.updateAppointmentBooking(mechanicPlanningViewModel);
        } else {
          this.saveAppointmentBooking(mechanicPlanningViewModel);
        }
      }
  }

  saveAppointmentBooking(_mechanicPlanningViewModel: SaveAppointmentPlanning) {
    // This is intentional
  }
  updateAppointmentBooking(_mechanicPlanningViewModel: SaveAppointmentPlanning) {
    // This is intentional
  }
  ValidateStartTime(): boolean {
    if ((this.startHours === "" || this.startHours === undefined) && (this.startMin === "" || this.startMin === undefined)) {
      this.toastr.error(this.translateService.instant('StartTime') + ' ' + this.translateService.instant('Required'));
      this.isValid = false;
      return false;
    }
    return true;
  }
  clearWorkorder(){
    this.appoitmentId = 0;
  }
  validateAppointmentBooking() {
    this.isValid = true;
    if (!this.isServicesAdded && this.isAddBooking) {
      this.showErrorMessage(fromEnums.ToastrMessages.AppointmentPlanningServiceNotAddedValidation);
    }
    else if(!this.isAddBooking)
    {
      if(this.appoitmentId <=0 || this.mechanicId <= 0){
       this.showErrorMessage(this.translateService.instant("lblSelectRequiredFields")) ;
      }
    }
    else {
      if (+this.durationHours == 0 && +this.durationMinutes == 0) {
        this.setStartDateAndTime();
        this.showErrorMessage(this.translateService.instant('Duration') + ' ' + this.translateService.instant('Required'));
      
      }else{
        this.checkMinuteValidation();
      }
    }
    return this.isValid;
  }
  checkMinuteValidation() {
    const durationMinuteCheck = +this.durationMinutes < 60 ? +this.durationMinutes % 15 !== 0 : true;
    const startTimeMinuteCheck = +this.startMin < 60 ? +this.startMin % 15 !== 0 : true;

    if (durationMinuteCheck || startTimeMinuteCheck) {
        this.showErrorMessage(fromEnums.ToastrMessages.MinutesValidation);
    }
}
showErrorMessage(message) {
  this.toastr.error(message);
  this.isValid = false;
}
  private GetDealerUnavailabilityDetails(_date?: any) {
    if (this.dealerWorkingHours?.length > 0) {
      this.disableDealerNotOpenDates();
    }
    if (this.dealerHolidays?.length > 0) {
      this.disableDatesOfCalender = this.disableDealerHolidayDates();
    }
  }


  MonthChangeFiredForStartDate(date: any) {
    this.GetDealerUnavailabilityDetails(date);
  }
  private findTime(time){
    let result = 0;
    if(time > 0 && time <=15){
        result = 15;
    }
    else if(time > 15 && time <=30){
        result = 30;
    }
    else if(time > 30 && time <=45){
        result = 45;
    }
    else if(time > 45 && time <=60){
        result = 60;
    }
    return result;
}
}
